import React from "react";

export default function Punishment(props) {
  return (
    <div>
      <h1 className="text-3xl font-bold mb-6 text-yellow-500">
        Punishment for false or malicious complaint and false evidence
      </h1>

      <div className="space-y-5">
        <div className="rounded-xl p-6 bg-white border border-gray-200 shadow-sm">
          <span className="text-gray-700">
            Where the Inquiry Committee arrives at the conclusion that the
            allegation against the respondent is malicious, or the complainant
            or any other person making the complaint has made the complaint
            knowing it to be false or the complainant or any other person making
            the complaint has produced any forged or misleading document, it may
            recommend to CEO,SS to take action against the complainant or the
            person who has made the complaint, as the case may be..
          </span>
        </div>
        <div className="rounded-xl p-6 bg-white border border-gray-200 shadow-sm">
          <span className="text-gray-700">
            While deciding malicious intent, the Inquiry Committee should
            consider that mere inability to substantiate a complaint or provide
            adequate proof need not attract action against the complainant /need
            not mean malicious intent. Malicious intent on part of the
            complainant shall be clearly established through a separate inquiry.
          </span>
        </div>
        <div className="rounded-xl p-6 bg-white border border-gray-200 shadow-sm">
          <span className="text-gray-700">
            Where the Inquiry Committee arrives at a conclusion that during the
            inquiry any witness has given false evidence or produced any forged
            or misleading documents, it may recommend to CEO,SS to take action
            against such a person.
          </span>
        </div>
      </div>
    </div>
  );
}
